import {DeleteProductSchemeModel, ProductSchemeModel} from '../Model'
import {actionTypes} from './constants'
import {IProductSchemeState} from './reducer'
import {ParamsModel} from 'src/app/modules/common/Model'
export const actions = {
  // get key
  getProductScheme: (params: any = {page: '', limit: ''}) => ({
    type: actionTypes.GET_PRODUCT_SCHEME_START,
    payload: {params},
  }),
  getProductSchemeSuccess: (data: any) => ({
    type: actionTypes.GET_PRODUCT_SCHEME_SUCCESS,
    payload: data,
  }),
  getProductSchemeError: (error: string) => ({
    type: actionTypes.GET_PRODUCT_SCHEME_FINISH,
    payload: {error},
  }),

  // get key
  getProductSchemeDropdown: () => ({
    type: actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_START,
    // payload: {params},
  }),
  getProductSchemeDropdownSuccess: (data: any) => ({
    type: actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_SUCCESS,
    payload: data,
  }),
  getProductSchemeDropdownError: (error: string) => ({
    type: actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_FINISH,
    payload: {error},
  }),

  // create key
  createProductScheme: (data: ProductSchemeModel) => ({
    type: actionTypes.ADD_PRODUCT_SCHEME_START,
    payload: data,
  }),
  createProductSchemeSuccess: (task: any) => ({
    type: actionTypes.ADD_PRODUCT_SCHEME_SUCCESS,
    payload: task,
  }),
  createProductSchemeFinish: (errorMsg: any) => ({
    type: actionTypes.ADD_PRODUCT_SCHEME_FINISH,
    payload: errorMsg,
  }),
  createProductSchemeReset: () => ({
    type: actionTypes.ADD_PRODUCT_SCHEME_RESET,
  }),

  // update key
  updateProductScheme: (data: ProductSchemeModel, id: string) => ({
    type: actionTypes.UPDATE_PRODUCT_SCHEME_START,
    payload: {data, id},
  }),
  updateProductSchemeSuccess: (task: any) => ({
    type: actionTypes.UPDATE_PRODUCT_SCHEME_SUCCESS,
    payload: task,
  }),
  updateProductSchemeFinish: (errorMsg: any) => ({
    type: actionTypes.UPDATE_PRODUCT_SCHEME_FINISH,
    payload: errorMsg,
  }),
  updateProductSchemeReset: () => ({
    type: actionTypes.UPDATE_PRODUCT_SCHEME_RESET,
  }),

  // UPDATE key
  deleteProductScheme: (data: DeleteProductSchemeModel[]) => ({
    type: actionTypes.DELETE_PRODUCT_SCHEME_START,
    payload: {table: 'scheme_types', id: data},
  }),
  deleteProductSchemeSuccess: (data: any) => ({
    type: actionTypes.DELETE_PRODUCT_SCHEME_SUCCESS,
    payload: data,
  }),
  deleteProductSchemeFinish: (errorMsg: any) => ({
    type: actionTypes.DELETE_PRODUCT_SCHEME_FINISH,
    payload: errorMsg,
  }),

  // single active branchless banking
  singleActivateBranchlessBanking: (id: {[key: string]: string}) => ({
    type: actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_REQUEST,
    payload: {table: 'scheme_types', id: [id]},
  }),
  // single deactive branchless banking
  singleDeactivateBranchlessBanking: (id: {[key: string]: string}) => ({
    type: actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_REQUEST,
    payload: {table: 'scheme_types', id: [id]},
  }),
}
